import React, { useContext, useState } from "react";
import { Card, Link, Collapsible, Caption, Layout, Stack, Heading, TextStyle, VideoThumbnail } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import { withErrorBoundary } from "lib/hoc";
import constant from "lib/constant/constant";

import standardList from "./settingConfig";

const AdminSettings = () => {
  const { cms } = useContext(PrivateContext);
  const [openSetup, setOpenSetup] = useState({});
  const { imageURL } = constant;

  const handleSetupToggle = (key) => {
    setOpenSetup((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const borderSet = {
    border: "0",
  };

  const iconHeightFix = {
    lineHeight: "2.2em",
  };

  return (standardList(cms) || []).map((settingList) => {
    return (
      <Layout.AnnotatedSection
        title={settingList.title}
        description={[
          <div>
            {settingList.isVideo && (
              <>
                <VideoThumbnail
                  videoLength={80}
                  // eslint-disable-next-line max-len
                  thumbnailUrl={imageURL.WELCOME}
                />
                <br />
              </>
            )}
            <TextStyle variation="subdued">{settingList.description}</TextStyle>
          </div>,
        ]}
      >
        {settingList.list.map((actionList) => {
          return (
            <Card>
              <Card.Header
                sectioned
                title={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Stack>
                    <i className={actionList.icon} style={iconHeightFix} />
                    <Heading>
                      {actionList.title}
                      <TextStyle variation="subdued">
                        <Caption>{actionList.description}</Caption>
                      </TextStyle>
                    </Heading>
                  </Stack>
                }
                actions={[
                  {
                    content: openSetup[actionList.code] ? "Hide" : "Show",
                    onAction: () => handleSetupToggle(actionList.code),
                    disclosure: openSetup[actionList.code] ? "up" : "down",
                  },
                ]}
              />
              <br />
              <Collapsible open={openSetup[actionList.code]} id={`collapsible${actionList.code}`}>
                <Card.Section subdued>
                  {actionList.actions.map((step) => {
                    return (
                      <div style={borderSet}>
                        <Card.Section subdued>
                          <Stack>
                            <Stack.Item>
                              <Link url={step.link}>{step.label}</Link>
                              <TextStyle variation="">
                                <Caption>{step.description}</Caption>
                              </TextStyle>
                            </Stack.Item>
                          </Stack>
                        </Card.Section>
                      </div>
                    );
                  })}
                  {actionList.isVideo && (
                    <Layout.AnnotatedSection
                      title={actionList.thumbnailHeader}
                      description={
                        // eslint-disable-next-line react/jsx-wrap-multilines
                        <div>
                          <VideoThumbnail videoLength={80} thumbnailUrl={actionList.thumbnail} />
                          <br />
                          <TextStyle variation="">{actionList.thumbnailDescription}</TextStyle>
                        </div>
                      }
                    />
                  )}
                </Card.Section>
              </Collapsible>
            </Card>
          );
        })}
      </Layout.AnnotatedSection>
    );
  });
};

export default withErrorBoundary(AdminSettings);
